import { z } from 'zod';

const ProtectionPolicySchema = z.object({
  content: z.string(),
  updated: z.number()
});

const PolicySchema = z.object({
  id: z.string().optional(),
  type: z.string(),
  created: z.number(),
  updated: z.number().optional(),
  title: z.string(),
  html: z.string(),
  default: z.boolean(),
  private: z.boolean().default(false)
});

export type ProtectionPolicyDocument = z.infer<typeof ProtectionPolicySchema>;
export type PolicyDocument = z.infer<typeof PolicySchema>;